export type ClassConstructor<T> = {
    new(...args: any[]): T;
};

export function transform<T>(
    DtoClass: ClassConstructor<T>,
    data: unknown[],
): T[];

export function transform<T>(
    DtoClass: ClassConstructor<T>,
    data: unknown,
): T;

export function transform<T>(
    DtoClass: ClassConstructor<T>,
    data: unknown | unknown[],
): T | T[] {
    if (!data) {
        return data as T;
    }
    if (data instanceof DtoClass) {
        return data;
    }
    if (Array.isArray(data)) {
        return data.map((item) => transform(DtoClass, item as unknown));
    }

    return new DtoClass(data);
}